"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceTokenType = void 0;
var ServiceTokenType;
(function (ServiceTokenType) {
    ServiceTokenType["Github"] = "github";
    ServiceTokenType["Gitlab"] = "gitlab";
    ServiceTokenType["Bitbucket"] = "bitbucket";
    ServiceTokenType["BaseSpace"] = "baseSpace";
    ServiceTokenType["Tamarind"] = "tamarind";
    ServiceTokenType["OpenAI"] = "openai";
    ServiceTokenType["Gemini"] = "gemini";
    ServiceTokenType["Anthropic"] = "anthropic";
    ServiceTokenType["GoogleCloud"] = "gCloud";
    ServiceTokenType["Custom"] = "custom";
})(ServiceTokenType || (exports.ServiceTokenType = ServiceTokenType = {}));
